import { useEffect } from 'react'
import { useAppBarScrim } from '../state-management/contexts/AppBarScrimContext'

export const useSetAppBarTheme = ({
  appBarTheme,
  keepThemeOnUnmount = false
}: {
  appBarTheme: 'light' | 'dark' | null
  keepThemeOnUnmount?: boolean
}) => {
  const { handleSetAppBarTheme } = useAppBarScrim()

  useEffect(() => {
    return () => {
      if (!keepThemeOnUnmount) {
        handleSetAppBarTheme(null)
      }
    }
  }, [])

  useEffect(() => {
    handleSetAppBarTheme(appBarTheme)
  }, [appBarTheme])
}
